import React, { useCallback, useState } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { ConditionalTooltip } from '@atlassian/jira-jql-builder-common/src/ui/conditional-tooltip/index.tsx';
import { ScreenReaderText } from '@atlassian/jira-accessibility/src/common/ui/screenreader-text/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { LozengeOption } from '../../../common/types.tsx';
import {
	PICKER_DROPDOWN_WIDTH,
	StyledLabel,
	StyledLozenge,
	StyledLozengeLabel,
	StyledOption,
} from '../../../common/ui/styled.tsx';

// Checkbox icon width = 3 * gridSize
// Margins and paddings around checkbox icon = 2 * gridSize
// Option right padding = (3 / 2) * gridSize
const DEFAULT_MAX_WIDTH = PICKER_DROPDOWN_WIDTH - 3 * gridSize - 2 * gridSize - (3 / 2) * gridSize;

type Props = {
	data: LozengeOption;
};

export const LozengeOptionLabel = ({ data }: Props) => {
	const [labelOverflows, setLabelOverflows] = useState(false);

	const onLabelRef = useCallback((node: HTMLElement | null) => {
		if (node != null) {
			setLabelOverflows(node.offsetWidth < node.scrollWidth);
		}
	}, []);

	return (
		<StyledOption>
			<StyledLabel>
				<StyledLozenge data-testid="jql-builder-basic-picker.ui.format-option-label.lozenge-option-label.lozenge">
					<Lozenge
						appearance={data.appearance}
						isBold={data.isBold}
						maxWidth={data.maxWidth ?? DEFAULT_MAX_WIDTH}
					>
						<ConditionalTooltip
							condition={labelOverflows}
							content={data.label}
							position="right"
							tag="span"
						>
							<StyledLozengeLabel ref={onLabelRef}>{data.label}</StyledLozengeLabel>
						</ConditionalTooltip>
					</Lozenge>
				</StyledLozenge>
			</StyledLabel>
			{data.disabledMessage && fg('jql_basic_picker_a11y_tooltip_fix_on_options') && (
				<ScreenReaderText>{data.disabledMessage}</ScreenReaderText>
			)}
		</StyledOption>
	);
};
export default LozengeOptionLabel;
